import { render, staticRenderFns } from "./jingshengongdezhifu.vue?vue&type=template&id=32189c3a&scoped=true"
import script from "./jingshengongdezhifu.vue?vue&type=script&lang=js"
export * from "./jingshengongdezhifu.vue?vue&type=script&lang=js"
import style0 from "./jingshengongdezhifu.vue?vue&type=style&index=0&id=32189c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32189c3a",
  null
  
)

export default component.exports